<template>
  <div>
    <b-form-group label="Tipo de disparador">
      <v-select
        v-model="trigger.type"
        :options="typeOptions"
        label="label"
        :reduce="(o) => o.value"
        placeholder="Seleccione el tipo de disparador"
      />
    </b-form-group>

    <template v-if="trigger.type === 'answer'">
      <b-form-group label="Pregunta que dispara la acción">
        <v-select
          v-model="trigger.question"
          :options="questionOptions"
          label="label"
          :reduce="(o) => o.name"
          placeholder="Seleccione una pregunta"
        />
      </b-form-group>
      <b-form-group label="Valor esperado de la respuesta (opcional)">
        <b-form-input
          v-model="trigger.value"
          placeholder="Opcional - Ej: si"
        />
      </b-form-group>
    </template>

    <b-form-group
      v-else
      label="Porcentaje de avance (%)"
    >
      <b-form-input
        v-model="trigger.value"
        type="number"
        min="0"
        max="100"
        placeholder="Ej: 100"
      />
    </b-form-group>

  </div>
</template>

<script>
export default {
  name: 'TriggerFields',
  props: {
    trigger: { type: Object, required: true },
    questionOptions: { type: Array, default: () => [] },
  },
  data() {
    return {
      typeOptions: [
        { value: 'answer', label: 'Al responder una pregunta' },
        { value: 'percent', label: 'Porcentaje de avance' },
      ],
    }
  },
}
</script>
